import { render, staticRenderFns } from "./PackingSlipCopyModal.vue?vue&type=template&id=c767a7e8"
import script from "./PackingSlipCopyModal.vue?vue&type=script&lang=js"
export * from "./PackingSlipCopyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports